import axios from "axios";

// Send new question to chat assistant
// params: { question: string, userId: number }
const post = ({ question, userId }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/ai/user_api/v1/new_question", {
        question,
        user_id: userId,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data ?? error));
  });
};

const chatAssistantNewQuestion = {
  post,
};

export default chatAssistantNewQuestion;
